import React, { Component } from 'react';
import Cleave from 'cleave.js/react';
import Formaters from '../../common/Formaters';
import { Run, RuleRunner } from '../Validation/RuleRunner'
import { required, regexMatch, emptyRegexMatch } from '../Validation/Rules';
import RegexValidator from '../Validation/RegexValidator';
import Config from "../../config"

const fieldValidations = [
  RuleRunner("lastName-0", "Le nom du responsable", required,regexMatch(RegexValidator.textOnly, "Le nom est incorrect")),
  RuleRunner("firstName-0", "Le prénom du responsable", required, regexMatch(RegexValidator.textOnly, "Le prénom est incorrect")),
  RuleRunner("email-0", "L'email du responsable", required, emptyRegexMatch(RegexValidator.email, "L'email est incorrect")),
  RuleRunner("phoneNumber-0", "Le téléphone mobile du responsable", required, emptyRegexMatch(RegexValidator.frMobilePhoneNumber, "Le numéro de téléphone est incorrect")),
];

export default class Responsibles extends Component {
  constructor(props) {
    super(props);
  
    this.state = {
      responsibles: props.responsibles,
      validationErrors: {},
    };
    
    // Make the onChange event
     this.handleChange = this.handleChange.bind(this);
  }

handleChange(event) {
  var responsibles = this.state.responsibles;
  const name = event.target.name;

  let key = name.split("-")[0];
  let index = name.split("-")[1];
  
  // If value is equal to on thus the element is a checkbox
  // so we get the checked value
  let value = event.target.rawValue;

  if (value === null || value === undefined) {
    value = event.target.value;
  }

  if (value === "on") {
    value = event.target.checked
  }

  // Update the businessHour object
  responsibles[index][key] = value;
  

  this.setState({
    responsibles: responsibles
  });


}

getErrors(index) {
  let responsibleToCheck = {};

  Object.keys(this.state.responsibles[index]).forEach((key) => {
    responsibleToCheck[key + "-" + index] = this.state.responsibles[index][key]
  });

  return Run(responsibleToCheck, fieldValidations);
}

/**
 * @return boolean false if there are some errors
 */
checkForm() {
  let errors = this.getErrors(0);

  this.setState({
    validationErrors: errors
  });

  return Object.keys(errors).length === 0;
}

  componentDidMount() {}

  componentWillUnmount() {}


  errorFor(field) {
    return this.state.validationErrors[field] || "";
  }

  getObject() {
    return this.state.responsibles;
  }

  renderView(responsible, index) {
    return (
      <fieldset className="form-fieldset" key={index} id={this.props.id}>
        <legend className="form-fieldset-legend">{responsible.capacity}</legend>

        <div className="row">
          <div className="mycol-4">
            <div className="form-group">
              <label className="label">Qualité du responsable : </label>
              <input name={"quality-" + index} type="text" placeholder="Qualité" className={"textbox textbox-full textbox-program-"+Config.program.style} onChange={this.handleChange} defaultValue={responsible.quality} />
              <span className="form-error">{this.errorFor("quality-" + index)}</span>
            </div>
          </div>
          <div className="mycol-4">
            <div className="form-group">
              <label className="label">Nom : </label>
              <input name={"lastName-" + index} type="text" placeholder="Nom" className={"textbox textbox-full textbox-program-"+Config.program.style} onChange={this.handleChange} defaultValue={responsible.lastName} />
              <span className="form-error">{this.errorFor("lastName-" + index)}</span>
            </div>
          </div>
          <div className="mycol-4">
            <div className="form-group">
              <label className="label">Prénom : </label>
              <input name={"firstName-" + index}  type="text" placeholder="Prénom" className={"textbox textbox-full textbox-program-"+Config.program.style} onChange={this.handleChange} defaultValue={responsible.firstName} />
              <span className="form-error">{this.errorFor("firstName-" + index)}</span>
            </div>
          </div>
        </div>


        <div className="row">
          <div className="mycol-6">

            <div className="form-group">
              <label className="label">Adresse E-mail pour envoi du contrat et communication administrative : </label>
              <input name={"email-" + index}  type="email" placeholder="Email" className={"textbox textbox-full textbox-program-"+Config.program.style} onChange={this.handleChange} defaultValue={responsible.email} />
              <span className="form-error">{this.errorFor("email-" + index)}</span>
            </div>
          </div>
          <div className="mycol-6">
            <div className="form-group">
              <label className="label">Téléphone mobile pour envoi du sms de validation du contrat : </label>
              <Cleave name={"phoneNumber-" + index}  type="text" placeholder="Téléphone" className={"textbox textbox-full textbox-program-"+Config.program.style} onChange={this.handleChange} value={responsible.phoneNumber}
                options={Formaters.phone}
              />
              <span className="form-error">{this.errorFor("phoneNumber-" + index)}</span>
            </div>
          </div>
        </div>
      </fieldset>
    );
  }

  render() {
    const elements = this.state.responsibles.map(
      (resp, index) => this.renderView(resp, index)
    );

    return (
      <div className="step step3 margin-top-m margin-bottom-m">
        <form className="form">
          {elements}
        </form>
      </div>
    );
  }
}


// WEBPACK FOOTER //
// ./src/components/Forms/Responsibles.js